import "./index.css";
export const Spinner = ({ title, size = "lg" }) => {
  const fontSize = size === "lg" ? "20px" : "14px";
  const marginTop = size === "lg" ? "16px" : "0px";

  return (
    <section
      style={{
        marginTop: "32px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "200px",
        width: "200px",
        position: "fixed",
        top: "25%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 9999,
      }}
    >
      <div
        className="lds-spinner"
        style={{ transform: size === "sm" && "scale(0.65)" }}
      >
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <p style={{ marginTop, fontSize }}>{title}</p>
    </section>
  );
};
